import ScreenSizeController from "./ScreenSizeController";
export default ScreenSizeController;
